<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Get Help'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">


    @if (loaded) {
      <!--TODO replace inline style https://trello.com/c/XpKJZqE7/9010-f-ca-address-inline-styles-->
      <tidy-card style="padding: 15px 15px 15px 10px">
        <tidy-row [align]="'center'" class="extra-bottom-padding">
          <tidy-text
            [title]="'What can we help with?'" />
        </tidy-row>
        <tidy-card-button (action)="howToUseTidy()">
          <tidy-grid>
            <tidy-row>
              <ion-row>
                <ion-col size="2" class="vertical-align-center">
                  <div style="margin: auto">
                    <tidy-image
                      [src]="'assets/img/home-heart.svg'"
                      style="width:25px" />
                  </div>
                </ion-col>
                <ion-col>
                  <tidy-row>
                    <tidy-text
                      [header]="'How to Use TIDY'" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [body]="'Ask a question about TIDY.'" />
                  </tidy-row>
                </ion-col>
              </ion-row>
            </tidy-row>
          </tidy-grid>
        </tidy-card-button>
        <tidy-card-button (action)="jobIssue()">
          <tidy-grid>
            <tidy-row>
              <ion-row>
                <ion-col size="2" class="vertical-align-center">
                  <div style="margin: auto">
                    <tidy-image
                      [src]="'assets/img/repair-tools.svg'"
                      style="width:25px" />
                  </div>
                </ion-col>
                <ion-col>
                  <tidy-row>
                    <tidy-text
                      [header]="cleaningId ? 'Issue with this Job' : 'Issue with a Job'" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [body]="cleaningId ? 'Notify us of an issue with this job/pro.' : 'Notify us of an issue with a job/pro.'" />
                  </tidy-row>
                </ion-col>
              </ion-row>
            </tidy-row>
          </tidy-grid>
        </tidy-card-button>
        <tidy-card-button (action)="billingIssue()">
          <tidy-grid>
            <tidy-row>
              <ion-row>
                <ion-col size="2" class="vertical-align-center">
                  <div style="margin: auto">
                    <tidy-image
                      [src]="'assets/img/billing-issue.svg'"
                      style="width:25px" />
                  </div>
                </ion-col>
                <ion-col>
                  <tidy-row>
                    <tidy-text
                      [header]="'Issue with Billing'" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [body]="'Ask us a question about charges or credits.'" />
                  </tidy-row>
                </ion-col>
              </ion-row>
            </tidy-row>
          </tidy-grid>
        </tidy-card-button>
        <tidy-card-button (action)="otherQuestion()">
          <tidy-grid>
            <tidy-row>
              <ion-row>
                <ion-col size="2" class="vertical-align-center">
                  <div style="margin: auto">
                    <tidy-image
                      [src]="'assets/img/help.svg'"
                      style="width:25px" />
                  </div>
                </ion-col>
                <ion-col>
                  <tidy-row>
                    <tidy-text
                      [header]="'Other'" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [body]="'Note: The slowest option'" />
                  </tidy-row>
                </ion-col>
              </ion-row>
            </tidy-row>
          </tidy-grid>
        </tidy-card-button>
      </tidy-card>
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
